import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import { push } from 'react-router-redux';
import { isErrorResponse } from '../../utils/error-handlers';
import {
  DEFAULT_GET_CONFIG,
  DEFAULT_POST_CONFIG,
  DEFAULT_PUT_CONFIG,
} from '../../config/rest';
import {
  CLEAR_DISCOUNT_CODE_CATEGORIES,
  CLEAR_DISCOUNT_CODE_CATEGORY,
  FLAG_DISCOUNT_CODE_CATEGORY_ACTIVITY,
  FLAG_GETTING_DISCOUNT_CODE_CATEGORIES,
  GET_DISCOUNT_CODE_CATEGORIES,
  GET_DISCOUNT_CODE_CATEGORY,
} from '../types';
import { DISCOUNT_CODE_CATEGORY_ENDPOINT } from '../../config/endpoints';
import { DISCOUNT_CODE_CATEGORY_PATH } from '../../config/paths';

const flagGettingDiscountCodeCategories = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_DISCOUNT_CODE_CATEGORIES,
    payload: flag,
  });

const getDiscountCodeCategories =
  async (tableFilters = null) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingDiscountCodeCategories(true));
      const query = tableFilters;
      const url = `${DISCOUNT_CODE_CATEGORY_ENDPOINT}?${QueryString.stringify(
        query,
      )}`;
      const response = await fetch(url, { ...DEFAULT_GET_CONFIG });
      await isErrorResponse(response, null, dispatch);
      const pricingProfiles = await response.json();
      dispatch({
        type: GET_DISCOUNT_CODE_CATEGORIES,
        payload: pricingProfiles,
      });
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagGettingDiscountCodeCategories(false));
    }
  };

const clearDiscountCodeCategories = () => (dispatch) =>
  dispatch({
    type: CLEAR_DISCOUNT_CODE_CATEGORIES,
  });

const clearDiscountCodeCategory = () => (dispatch) =>
  dispatch({
    type: CLEAR_DISCOUNT_CODE_CATEGORY,
  });

const flagDiscountCodeCategoryActivity = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_DISCOUNT_CODE_CATEGORY_ACTIVITY,
    payload: flag,
  });

const postDiscountCodeCategory =
  async ({ name, description, discountCodeSubCategoryList, active }) =>
  async (dispatch) => {
    try {
      dispatch(flagDiscountCodeCategoryActivity(true));

      const payload = {
        name,
        description,
        discountCodeSubCategoryList,
        active,
      };

      const url = DISCOUNT_CODE_CATEGORY_ENDPOINT;

      const response = await fetch(url, {
        ...DEFAULT_POST_CONFIG,
        body: JSON.stringify(payload),
      });

      await isErrorResponse(response, null, dispatch);

      const discountCodeCategory = await response.json();

      dispatch(
        push(`${DISCOUNT_CODE_CATEGORY_PATH}/${discountCodeCategory.id}`),
      );
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagDiscountCodeCategoryActivity(false));
    }
  };

const putDiscountCodeCategory =
  async (
    discountCodeCategoryId,
    { name, description, discountCodeSubCategoryList, active },
  ) =>
  async (dispatch) => {
    try {
      dispatch(flagDiscountCodeCategoryActivity(true));

      const payload = {
        id: discountCodeCategoryId,
        name,
        description,
        discountCodeSubCategoryList,
        active,
      };

      const url = `${DISCOUNT_CODE_CATEGORY_ENDPOINT}/${discountCodeCategoryId}`;

      const response = await fetch(url, {
        ...DEFAULT_PUT_CONFIG,
        body: JSON.stringify(payload),
      });

      await isErrorResponse(response, null, dispatch);

      const discountCodeCategory = await response.json();

      dispatch(
        push(`${DISCOUNT_CODE_CATEGORY_PATH}/${discountCodeCategory.id}`),
      );
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagDiscountCodeCategoryActivity(false));
    }
  };
const getDiscountCodeCategory =
  async ({ discountCodeCategoryId }) =>
  async (dispatch) => {
    try {
      dispatch(flagDiscountCodeCategoryActivity(true));

      const url = `${DISCOUNT_CODE_CATEGORY_ENDPOINT}/${discountCodeCategoryId}`;

      const response = await fetch(url, { ...DEFAULT_GET_CONFIG });

      await isErrorResponse(response, null, dispatch);

      const discountCodeCategory = await response.json();

      dispatch({
        type: GET_DISCOUNT_CODE_CATEGORY,
        payload: discountCodeCategory,
      });
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagDiscountCodeCategoryActivity(false));
    }
  };

export {
  flagGettingDiscountCodeCategories,
  getDiscountCodeCategories,
  clearDiscountCodeCategories,
  clearDiscountCodeCategory,
  postDiscountCodeCategory,
  putDiscountCodeCategory,
  getDiscountCodeCategory,
};
